import { useNavigate } from 'react-router-dom';
import { ShieldExclamationIcon, ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/common';
import { useAuthStore } from '@/store/auth';
import { homePathForRole } from '@/routing/portalHome';

/**
 * Access Denied.
 *
 * #365: this used to be a full-screen page OUTSIDE the dashboard layout, so a
 * refused user lost the sidebar and header and was stuck. It now renders
 * inside DashboardLayout (see App.tsx), keeping the normal navigation, and
 * offers two ways out: the user's own home (the insurer dashboard for an
 * insurer, /dashboard for everyone else) and Back.
 */
export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const home = homePathForRole(user?.role);

  return (
    <div className="flex items-center justify-center py-16 px-4">
      <div className="text-center max-w-md">
        <ShieldExclamationIcon className="mx-auto h-16 w-16 text-red-500" aria-hidden="true" />
        <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">Access Denied</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          You don&apos;t have permission to access this page.
        </p>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Use the menu to open a page available to you, or go back.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Button leftIcon={<HomeIcon className="w-5 h-5" />} onClick={() => navigate(home)}>
            Go to Dashboard
          </Button>
          <Button
            variant="outline"
            leftIcon={<ArrowLeftIcon className="w-5 h-5" />}
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
